import { render, staticRenderFns } from "./CloseoutSnapshotReviewTable.vue?vue&type=template&id=bc8af7a6&"
import script from "./CloseoutSnapshotReviewTable.vue?vue&type=script&lang=js&"
export * from "./CloseoutSnapshotReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports